import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=f144d99e&scoped=true&lang=pug"
import script from "./Videos.vue?vue&type=script&lang=ts"
export * from "./Videos.vue?vue&type=script&lang=ts"
import style0 from "./Videos.vue?vue&type=style&index=0&id=f144d99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f144d99e",
  null
  
)

/* custom blocks */
import block0 from "@locales/de/de.yml?namespace=ui.views.contents.videos?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fpages%2Fcontents%2FVideos.vue&locale=de&lang=yaml&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@locales/en/en.yml?namespace=ui.views.contents.videos?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fpages%2Fcontents%2FVideos.vue&locale=en&lang=yaml&external"
if (typeof block1 === 'function') block1(component)

export default component.exports